// Content types whose pages must stay out of search engines - today the
// lead-gen template used for paid-campaign landing pages. This single list
// drives both sides of the contract:
//  - the layout renders <meta name="robots" content="noindex, nofollow">
//    on these pages (components/layout/main.tsx)
//  - the sitemap omits their routes (scripts/src/build-sitemap.ts)
// tests/specs/build-output.spec.ts cross-checks the built output so the two
// can never silently disagree.
export const noindexContentTypes = ['leadGen'];

// Page component names are the content type with the first letter
// upper-cased (see util/server/static-paths.ts).
export function isNoindexComponent(componentName: string): boolean {
  return noindexContentTypes.some(
    (ct) => ct.charAt(0).toUpperCase() + ct.slice(1) === componentName
  );
}
